import { Dtos, ExtractionStatus } from "@inrev/common";
import type { Option } from "@inrev/core";

const isExtractionInProgress = (extraction: Dtos.FinancialExtraction.Get.Response): boolean =>
	extraction.status === ExtractionStatus.NotStarted ||
	extraction.status === ExtractionStatus.Pending;

export function hasPendingFinancialExtraction(
	financialExtractions: Option<Dtos.FinancialExtraction.Get.Response[]>,
): boolean {
	return financialExtractions?.some(isExtractionInProgress) ?? false;
}
